// Client entry referenced from src/index.html. Imports `./i18n` for its
// init side effect before the React tree mounts so first paint already
// has translations available.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import { App } from "./App";
const elem = document.getElementById("root");
if (!elem) throw new Error("#root not found in index.html");
const app = <StrictMode>
		<App />
	</StrictMode>;
if (import.meta.hot) {
  const root = import.meta.hot.data.root ??= createRoot(elem);
  root.render(app);
} else {
  createRoot(elem).render(app);
}